import { RowModel } from './page-components/row.model';
import { Page } from './page-components/page.model';
import { Media } from './page-components/media.model';
import { Css } from './page-components/css.model';

export class PageModel {
  Id: number = 0;
  Active: boolean = false;
  ProjectId: number = 0;
  PageId: number = 0;
  Name?: string;
  Url?: string;
  Title?: string;
  MetaDescription?: string;
  MainImage?: Media;
  Content?: string;
  ExcludeFromSitemap: boolean = false;
  Published: Date = new Date();
  Rows: RowModel[] = [];
  PageStyle: Page = new Page();
  Style?: string;
  Css?: Css;
}
